import { COLUMN_DATE, COLUMN_TIME, COLUMN_SERIAL_ADDRESS, COLUMN_TAG_CODE, COLUMN_TYPE, COLUMN_DESCRIPTION, COLUMN_DETAILS, COLUMN_DISPLAY_NAME, COLUMN_UNIQUE_IDENTIFIER, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_BUTTON, COLUMN_CLOCKING_EVENT } from "../../constants/column-types";
import { FILTER_DATE } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const TnaTransactionColumn: TableColumn[] = [
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 0,
        searchOnName:"dateOnly",
        sortByName: "dateOnly",
        sortDirection: "asc",
        active: true,
        translationKey: "date",
        columnId: COLUMN_DATE,
        filterId: FILTER_DATE,
        settingDataName: "date",
        hideLookup: true
    },
    {
        heading: "Time",
        accessor: "time",
        isNumeric: false,
        id: 1,
        sortByName: "btrTime",
        sortDirection: "asc",
        active: true,
        translationKey: "time",
        columnId: COLUMN_TIME,
    },
    {
        heading: "User ID Csn",
        accessor: "userIdCsn",
        isNumeric: false,
        id: 2,
        sortByName: "btrCol1",
        sortDirection: "asc",
        active: true,
        translationKey: "userIdCsn",
        columnId: COLUMN_TAG_CODE,
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 3,
        sortByName: "btrDisplayname",
        sortDirection: "asc",
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 4,
        sortByName: "btrFirstname",
        sortDirection: "asc",
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME,
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 5,
        sortByName: "btrLastname",
        sortDirection: "asc",
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME,
    },
    {
        heading: "Id Number",
        accessor: "idNumber",
        isNumeric: false,
        id: 6,
        sortByName: "btrIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Button",
        accessor: "button",
        isNumeric: false,
        id: 7,
        sortByName: "btrType",
        sortDirection: "asc",
        active: true,
        translationKey: "button",
        columnId: COLUMN_BUTTON,
    },
    {
        heading: "Button Text",
        accessor: "buttonName",
        isNumeric: false,
        id: 8,
        sortByName: "btrKeyName",
        sortDirection: "asc",
        active: true,
        translationKey: "clockingEvent",
        columnId: COLUMN_CLOCKING_EVENT,
    },
    {
        heading: "Type",
        accessor: "biometricMake",
        isNumeric: false,
        id: 9,
        sortByName: "bioType.bioMake",
        sortDirection: "asc",
        active: false,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Description",
        accessor: "biometricType",
        isNumeric: false,
        id: 10,
        sortByName: "bioType.trnName",
        sortDirection: "asc",
        active: false,
        translationKey: "description",
        columnId: COLUMN_DESCRIPTION,
    },
    {
        heading: "Serial Address",
        accessor: "serialAddress",
        isNumeric: false,
        id: 11,
        sortByName: "btrSerial",
        sortDirection: "asc",
        active: true,
        translationKey: "serialAddress",
        columnId: COLUMN_SERIAL_ADDRESS,
    }
]

export default TnaTransactionColumn;
